import React from 'react'
import BlogPosts from '../components/BlogPosts'
import DashboardBlog from './DashboardBlog'
import Footer from '../components/Footer'

const Blog = () => {
  return (
    <> 
    <DashboardBlog />
    <BlogPosts />
    <Footer />
    </>
  )
}

export default Blog